<template>
    <div class="loader-wrapper" v-if="loading">
        <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
</template>
<style scoped src="./Loader.css"></style>
<script src="./Loader.js"></script>